export const isInternalUrl = (value: string) => {
  const { origin } = window.location
  const url = new URL(value)

  return origin.includes(url.origin)
}

export const getPathnameFromUrl = (value: string) => {
  const url = new URL(value)

  return url.pathname
}

const MEETING_LINK_PATTERN = /\/m\/([0-9a-z]{20,26})(?:$|[?#])/

export const getMeetingCodeFromUrl = (value: string, apiOrigins: string[]) => {
  try {
    const url = new URL(value)
    const isOurs = [window.location.origin, ...apiOrigins].filter(Boolean).some((origin) => {
      try {
        return new URL(origin).origin === url.origin
      } catch {
        return false
      }
    })

    if (!isOurs) {
      return undefined
    }

    return url.pathname.match(MEETING_LINK_PATTERN)?.[1]
  } catch {
    return undefined
  }
}
